// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Util_Float = require("../util/Util_Float.bs.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Particle_Screen_Ds = require("../design-system/particle/Particle_Screen_Ds.bs.js");

var r4_1 = {
  width: 4,
  height: 1
};

var r11_4 = {
  width: 11,
  height: 4
};

var r16_9 = {
  width: 16,
  height: 9
};

var r9_16 = {
  width: 9,
  height: 16
};

var r4_3 = {
  width: 4,
  height: 3
};

var r3_4 = {
  width: 3,
  height: 4
};

var r2_3 = {
  width: 2,
  height: 3
};

var r1_1 = {
  width: 1,
  height: 1
};

function make(ratio) {
  if (ratio === "R16_9") {
    return {
            NAME: "R16_9",
            VAL: r16_9
          };
  } else if (ratio === "R9_16") {
    return {
            NAME: "R9_16",
            VAL: r9_16
          };
  } else if (ratio === "Unknow") {
    return "Unknow";
  } else if (ratio === "R1_1") {
    return {
            NAME: "R1_1",
            VAL: r1_1
          };
  } else if (ratio === "R2_3") {
    return {
            NAME: "R2_3",
            VAL: r2_3
          };
  } else if (ratio === "R3_4") {
    return {
            NAME: "R3_4",
            VAL: r4_3
          };
  } else if (ratio === "R4_1") {
    return {
            NAME: "R4_1",
            VAL: r4_1
          };
  } else if (ratio === "R4_3") {
    return {
            NAME: "R4_3",
            VAL: r3_4
          };
  } else {
    return {
            NAME: "R11_4",
            VAL: r11_4
          };
  }
}

function getDimensions(t) {
  if (typeof t === "object") {
    return Caml_option.some(t.VAL);
  }
  
}

function areRatioEquals(r1, r2) {
  var match = getDimensions(r1);
  var match$1 = getDimensions(r2);
  if (match !== undefined && match$1 !== undefined && match.width === match$1.width) {
    return match.height === match$1.height;
  } else {
    return false;
  }
}

function divide(w, h) {
  return Util_Float.keepNdecimal(w / h, 1);
}

function divideDimensions(dimensions) {
  return divide(dimensions.width, dimensions.height);
}

function getFromRatio(ratioValue) {
  if (ratioValue !== undefined) {
    if (ratioValue === Util_Float.keepNdecimal(divideDimensions(r1_1), 1)) {
      return "R1_1";
    } else if (ratioValue === Util_Float.keepNdecimal(divideDimensions(r2_3), 1)) {
      return "R2_3";
    } else if (ratioValue === Util_Float.keepNdecimal(divideDimensions(r4_3), 1)) {
      return "R4_3";
    } else if (ratioValue === Util_Float.keepNdecimal(divideDimensions(r16_9), 1)) {
      return "R16_9";
    } else if (ratioValue === Util_Float.keepNdecimal(divideDimensions(r9_16), 1)) {
      return "R9_16";
    } else if (ratioValue === Util_Float.keepNdecimal(divideDimensions(r11_4), 1)) {
      return "R11_4";
    } else if (ratioValue === Util_Float.keepNdecimal(divideDimensions(r4_1), 1)) {
      return "R4_1";
    } else if (ratioValue === Util_Float.keepNdecimal(divideDimensions(r3_4), 1)) {
      return "R3_4";
    } else {
      return "Unknow";
    }
  } else {
    return "Unknow";
  }
}

function computeRatio(w, h) {
  if (h !== 0) {
    return divide(w, h);
  }
  
}

function makeFromDimensions(w, h) {
  return make(getFromRatio(computeRatio(w, h)));
}

var Ratio = {
  areRatioEquals: areRatioEquals,
  makeFromDimensions: makeFromDimensions,
  make: make,
  getDimensions: getDimensions
};

function make$1(ratios) {
  return Particle_Screen_Ds.map(make, ratios);
}

var RatioResponsive = {
  make: make$1
};

function toString(t) {
  switch (t) {
    case /* W1920xH1080 */0 :
        return "1920x1080";
    case /* W1400xH788 */1 :
        return "1400x788";
    case /* W1280xH720 */2 :
        return "1280x720";
    case /* W1200xH430 */3 :
        return "1200x430";
    case /* W940xH530 */4 :
        return "940x530";
    case /* W720xH406 */5 :
        return "720x406";
    case /* W450xH162 */6 :
        return "450x162";
    case /* W400xH400 */7 :
        return "400x400";
    case /* W400xH225 */8 :
        return "400x225";
    case /* W300xH450 */9 :
        return "300x450";
    case /* W300xH170 */10 :
        return "300x170";
    case /* W200xH200 */11 :
        return "200x200";
    
  }
}

function toDimensions(t) {
  switch (t) {
    case /* W1920xH1080 */0 :
        return {
                width: 1920,
                height: 1080
              };
    case /* W1400xH788 */1 :
        return {
                width: 1400,
                height: 788
              };
    case /* W1280xH720 */2 :
        return {
                width: 1280,
                height: 720
              };
    case /* W1200xH430 */3 :
        return {
                width: 1200,
                height: 430
              };
    case /* W940xH530 */4 :
        return {
                width: 940,
                height: 530
              };
    case /* W720xH406 */5 :
        return {
                width: 720,
                height: 406
              };
    case /* W450xH162 */6 :
        return {
                width: 450,
                height: 162
              };
    case /* W400xH400 */7 :
        return {
                width: 400,
                height: 400
              };
    case /* W400xH225 */8 :
        return {
                width: 400,
                height: 225
              };
    case /* W300xH450 */9 :
        return {
                width: 300,
                height: 450
              };
    case /* W300xH170 */10 :
        return {
                width: 300,
                height: 170
              };
    case /* W200xH200 */11 :
        return {
                width: 200,
                height: 200
              };
    
  }
}

var Size = {
  toString: toString,
  toDimensions: toDimensions
};

function makeDefault(size) {
  return "https://api.arte.tv/api/mami/v1/default/" + toString(size) + "";
}

var Mami = {
  Size: Size,
  makeDefault: makeDefault
};

exports.Ratio = Ratio;
exports.RatioResponsive = RatioResponsive;
exports.Mami = Mami;
/* No side effect */
